import { registerIconAlias } from '@fluentui/style-utilities';

export const registerIconAliases = (): void => {
  registerIconAlias('trash', 'delete');
  registerIconAlias('onedrive', 'onedrivelogo');
  registerIconAlias('alertsolid12', 'eventdatemissed12');
  registerIconAlias('sixpointstar', '6pointstar');
  registerIconAlias('twelvepointstar', '12pointstar');
  registerIconAlias('toggleon', 'toggleleft');
  registerIconAlias('toggleoff', 'toggleright');
};

export default registerIconAliases;
